<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import DbButton from "@/components/DB-Components/DbButton.vue";
import { reAuthorize } from "@/services/auth/re-auth";
import store from "@/store";
import router from "@/router";
import { isFieldRequired, isFieldValid } from "@/utils/users/methods";
import OrderLicensePlateInput from "@/components/orders/OrderLicensePlateInput.vue";

export default defineComponent({
  name: "LicensePlatform",

  components: {
    DbButton,
    OrderLicensePlateInput,
  },

  setup() {
    const isLoading = ref(true);
    const LicensePlatform = ref({
      license_plate: "",
      user_id: "",
    });

    const form = ref({
      errors: {},
      processing: false,
    });

    onMounted(() => {
      reAuthorize(store).then((res) => {
        store
          .dispatch("UserStore/getUser", store.state.user.data.user_id)
          .then((response) => {
            LicensePlatform.value = response;
            isLoading.value = false;
            console.log(LicensePlatform.value);
          });
      });
    });

    const update = async () => {
      form.value.processing = true;
      if (!isFormValid()) {
        return;
      }
      await store
        .dispatch("UserStore/editUser", LicensePlatform.value)
        .then((res) => {
          router.push("/");
        })
        .catch((error) => {
          const data = error?.response?.data;
          const errorStatus = data?.httpCode;
          if (errorStatus == 403) {
            form.value.errors = data.httpMessage;
          }
        });
    };

    const getTypedKeys = <T extends object>(obj: T): Array<keyof T> => {
      return Object.keys(obj) as Array<keyof T>;
    };

    const isFormValid = () => {
      let isFilled = true;
      const allFieldsValid = getTypedKeys(LicensePlatform.value).every(
        (fieldName) => isFieldValid(fieldName, LicensePlatform.value)
      );
      if (!allFieldsValid) return false;

      if (form.value.processing == false) {
        isFilled =
          getTypedKeys(LicensePlatform.value).filter(
            (fieldName) =>
              isFieldRequired(fieldName) &&
              (LicensePlatform.value[fieldName] == null ||
                LicensePlatform.value[fieldName]?.length == 0)
          ).length > 0
            ? false
            : true;
        return isFilled;
      }
      return true;
    };

    return {
      LicensePlatform,
      form,
      update,
      isFormValid,
      isFieldValid,
      isLoading,
      router,
    };
  },
});
</script>

<template>
  <div v-if="!isLoading" id="profile">
    <div class="flex flex-col jutify-center mt-[50%] p-2 mx-2">
      <div
        :class="{
          'pb-[26px]':
            !form.processing || isFieldValid('license_plate', LicensePlatform),
          'pb-0':
            !isFieldValid('license_plate', LicensePlatform) && form.processing,
        }"
        class="w-full flex flex-col items-center"
      >
        <div class="flex w-full flex-col">
          <p class="self-end text-sm">{{ $t("account.required") }}</p>
          <p class="self-start text-sm">
            {{ $t("account.license_plate_message") }}
          </p>
        </div>
        <OrderLicensePlateInput
          v-model="LicensePlatform.license_plate"
          :value="LicensePlatform.license_plate"
          :placeholder="$t('account.license_plate') + '*'"
          :label="$t('account.license_plate') + '*'"
          :ariainvalid="
            !isFieldValid('license_plate', LicensePlatform) && form.processing
              ? 'true'
              : undefined
          "
        ></OrderLicensePlateInput>
        <span
          v-if="
            !isFieldValid('license_plate', LicensePlatform) && form.processing
          "
          class="text-red-500"
          v-html="$t('order.errorLicensePlate')"
        >
        </span>
      </div>
      <div class="flex flex-col gap-4">
        <div class="w-full flex items-center justify-center">
          <DbButton
            class="w-full"
            @click="() => router.push('/')"
            variant="secondary-solid"
            >{{ $t("account.cancel") }}</DbButton
          >
        </div>
        <div class="w-full flex items-center justify-center">
          <DbButton @click="update" variant="primary">{{
            $t("account.save")
          }}</DbButton>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
#profile
  .elm-input.sc-db-input:not(:placeholder-shown):not(
    :has(+ label[data-label-hidden="true"])
  ).sc-db-input {
  padding-top: 1rem !important;
}
</style>
